export default "__VITE_ASSET__D_H_fxhh__"